import fs from 'fs';
import _ from 'lodash';
import crypto from 'crypto';
import zlib from 'zlib';

export const crawl = (user, allValues) => {
    if (!allValues) allValues = [];
    for (var key in user) {
        if (typeof user[key] === 'object') crawl(user[key], allValues);
        else allValues.push(user[key] + ' ');
    }
    return allValues;
};

export const removeDupes = (myArr) => {
    let myArrSerialized = myArr.map((e) => JSON.stringify(e));

    const mySetSerialized = new Set(myArrSerialized);
    const myUniqueArrSerialized = [...mySetSerialized];
    const myUniqueArr = myUniqueArrSerialized.map((e) => JSON.parse(e));
    // console.log(myUniqueArr.length);
    return myUniqueArr;
};

export const arrComparer = (compArr) => {
    return function (current) {
        return (
            compArr.filter(function (other) {
                return (
                    other.application_id == current.application_id &&
                    // other.current_name == current.current_name &&
                    other.application_name == current.application_name &&
                    other.activity_name == current.activity_name &&
                    other.domain_name == current.domain_name
                );
            }).length == 0
        );
    };
};

export const fsStore = (myArr, name) => {
    try {
        // convert JSON object to string
        const jsa = JSON.stringify(myArr);

        // write JSON string to a file
        fs.writeFile(name + '.json', jsa, (err) => {
            if (err) {
                throw err;
            }
            console.log('JSON data is saved.');
        });
    } catch (err) {
        console.log(err);
    }
};

export function uniqueByKey(array, key) {
    try {
        return [...new Map(array.map((x) => [x[key], x])).values()];
    } catch (err) {
        console.log(err);
        return [];
    }
}

export const getArrEquals = (arr1, arr2) => {
    try {
        console.log(arr1, arr2);
        return _.isEqual(arr1.sort(), arr2.sort());
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const processSum = (omitKey, data) => {
    try {
        return _.omit(
            _.mergeWith({}, ...data, (objValue = 0, srcValue = 0) => +objValue + +srcValue),
            omitKey
        );
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const catComp = (data, a, b) => {
    let leCounter = 0;
    let deCounter = 0;
    try {
        data.map((x) => {
            !_.isEqual(x[a].replace(/\s/g, '').split(',').sort(), x[b].replace(/\s/g, '').split(',').sort()) ? leCounter++ : deCounter++;
        });
        return [leCounter, deCounter];
    } catch (err) {
        console.log(err);
        return [leCounter, deCounter];
    }
};

export const searchRec = (list, text, key) => list.filter((i) => i[key].toLowerCase().includes(text.toLowerCase()));

export const getArrDists = (jsArr) => {
    try {
        return _.union(jsArr.join(',').split(',').sort());
    } catch (err) {
        console.log(err);
        return {};
    }
};

export const reduceMap = (arrA, arrB) => {
    try {
        return _.difference(arrA, arrB).length === 0;
    } catch (err) {
        console.log(err);
        return null;
    }
};

/*
  Description: Array reducer for connector changes under release page
  Input: Json array from fetConRelActsMods
  Output: Transformed json array with activities [] in a single js object 
  Usage Page: https://notify.netskope.com/connector_changes 
  */
export const conActReducer = (arr) => {
    return arr.reduce((acc, item) => {
        const found = acc.find((i) => i.current_name === item.current_name && i.release_name === item.release_name);

        if (found) {
            found.activity_name.push(item.activity_name);
        } else {
            acc.push({
                id: item.id,
                application_id: item.application_id,
                connector_type: item.connector_type,
                current_name: item.current_name,
                release_name: item.release_name,
                action: item.action,
                activity_name: [item.activity_name],
            });
        }

        return acc;
    }, []);
};

// Helper function to get encryption keys from secure config or environment variables
const getEncryptionKeys = () => {
    // Try to get from global secure config first
    if (typeof window !== 'undefined' && window.getSecureConfig) {
        try {
            const config = window.getSecureConfig();
            if (config && config.app_key && config.app_salt) {
                return {
                    appKey: config.app_key,
                    appSalt: config.app_salt
                };
            }
        } catch (err) {
            console.warn('Failed to get encryption keys from secure config:', err);
        }
    }
    
    // No fallbacks to environment variables - secure config is the only source
    console.warn('No encryption keys available from secure config - initialise API must be called first');
    return {
        appKey: null,
        appSalt: null
    };
};

export const decryptAndDeCompress = (compressed, usr, appKey = null, appSalt = null) => {
    try {
        const receivedCompressedData = Buffer.from(compressed, 'base64');

        // Decompress the data using zlib
        const decompressed = zlib.inflateSync(receivedCompressedData).toString('utf8');

        // Use provided key/salt, or get from secure config, or fallback to environment variables
        const keys = getEncryptionKeys();
        const key = crypto.pbkdf2Sync(
            (appKey || keys.appKey) + '_' + usr.slice(0, 2),
            appSalt || keys.appSalt,
            100000,
            16,
            'sha512'
        );

        // Decrypt the data using the key
        const decipher = crypto.createDecipheriv('aes-128-cbc', key, Buffer.alloc(16, 0));
        let decrypted = decipher.update(decompressed, 'hex', 'utf8');
        decrypted += decipher.final('utf8');

        // xml2js.parseString(JSON.parse(decrypted)?.['resp'], { explicitArray: false }, (err, result2) => {
        //     if (err) {
        //         console.error('Error parsing XML:', err);
        //     } else {
        //         const arrB = result2['soapenv:Envelope']['soapenv:Body']['loginResponse']?.['result']['userInfo'];
        //         console.log(arrB);
        //     }
        // });
        return decrypted;
    } catch (error) {
        console.log(error);
        return error;
    }
};

export const encryptAndCompress = (data, usr, appKey = null, appSalt = null) => {
    try {
        // Convert the data to a string for encryption
        const jsonData = JSON.stringify(data);
        
        // Use provided key/salt, or get from secure config, or fallback to environment variables
        const keys = getEncryptionKeys();
        const key = crypto.pbkdf2Sync(
            (appKey || keys.appKey) + '_' + usr.slice(0, 2),
            appSalt || keys.appSalt,
            100000,
            16,
            'sha512'
        );
        // console.log('key', key);

        // Encrypt the data using AES-128-CBC
        const cipher = crypto.createCipheriv('aes-128-cbc', key, Buffer.alloc(16, 0));
        let encrypted = cipher.update(jsonData, 'utf8', 'hex');
        encrypted += cipher.final('hex');

        // console.log('Encrypted Data:', encrypted.length);

        // Compress the encrypted data using zlib
        const compressed = zlib.deflateSync(encrypted);
        // console.log('compressed - ', compressed.length);
        const base64CompressedData = compressed.toString('base64');
        // console.log('base64CompressedData - ', base64CompressedData.length);
        return base64CompressedData;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// Simple encryption utilities for init keys (ROT13 + Base64)
export const simpleEncrypt = (text) => {
    // ROT13 + Base64 encoding (simple, reversible)
    const rot13 = text.replace(/[a-zA-Z]/g, function (c) {
        return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
    });
    return Buffer.from(rot13).toString('base64');
};

export const simpleDecrypt = (encrypted) => {
    // Base64 decode + ROT13
    const decoded = Buffer.from(encrypted, 'base64').toString('utf8');
    return decoded.replace(/[a-zA-Z]/g, function (c) {
        return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
    });
};
